import React from 'react';
import PropTypes from 'prop-types';
import styles from './DisabledAddToCart.module.scss';
import DisabledButton from '../DisabledButton';

const emptyCallback = () => {};

const DisabledAddToCart = ({ addToCartButtonTitle }) => (
  <div className={styles.container}>
    <div className={styles['add-to-cart-button-container']}>
      <DisabledButton
        onClick={emptyCallback}
        isLoading={false}
        title={addToCartButtonTitle}
        disabled
      />
    </div>
  </div>
);

DisabledAddToCart.propTypes = {
  addToCartButtonTitle: PropTypes.string.isRequired,
};

export default DisabledAddToCart;
